import React, { Fragment, useRef, useState } from "react";
import "./Toggle.css";
import {getAuthorization} from "../../../axios/AxiosAut";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import "animate.css";
import * as Yup from "yup";
import SupplierListTableData from "./SupplierListTableData";
import { useNavigate } from "react-router-dom";
import SupplierToggle from "./SupplierToggle";
import Suppliercards from "./Suppliermanagment/Suppliercards";
import { useDispatch, useSelector } from "react-redux";

function SupplierDashboard() {
  const [Toggle, setToggle] = useState("Overview");
  const Navigate = useNavigate();
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addsupplier = Permissions.find((o) => o.codename === "add_supplier");

  const toggleHandler = () => {
    if (Toggle == "List") {
      setToggle("Overview");
    } else {
      setToggle("List");
    }
  };

  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              {Toggle == "Overview" ? (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Suppliers Dashboard
                  </h2>
                  <div className="border-b-2 border-blue-200 w-24"></div>
                </>
              ) : (
                <>
                  {" "}
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Suppliers
                  </h2>
                  <div className="border-b-2 border-blue-200 w-12"></div>
                </>
              )}
            </div>
          </div>
          <div>
            {Toggle == "Overview" ? null : 
            !addsupplier ===undefined ||  addsupplier?.codename ===
              "add_supplier" ? (
              <button
                type="button"
                onClick={() =>
                  Navigate(
                    "/dashboard/management/supplier-dashboard/add-supplier"
                  )
                }
                className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
              >
                Add Supplier
              </button>
            ) : null
          }
          </div>
        </div>
        <SupplierToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      </div>
        <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        {Toggle == "Overview" ? <Suppliercards/> : <SupplierListTableData />}
              </div>
    </>
  );
}

export default SupplierDashboard;
